import { COMMON_TEXT } from '@/helpers/common-text';
import { generateRandomString } from '@/helpers/utility';
import { Tooltip } from 'primereact/tooltip';
import { MapAvailableIcon, MapOccupiedIcon } from '@/components/communication/MeetingRoomUsage/MeetingRoomUsageMap/icons';
import React from 'react';

export const MeetingRoomUsageMarkerRender = props => {
  const { item } = props;
  const { data } = item;
  const {
    room_availability,
    current_reservation,
    next_reservation,
    device_name,
  } = data;
  const isAvailable = room_availability === 1;
  const targetId = generateRandomString(12);

  const markerOnClicked = ({ data }) => {
    if (props.markerOnClicked) {
      props.markerOnClicked({ data });
    }
  };

  const MarkerIcon = () => {
    if (isAvailable) {
      return <MapAvailableIcon />;
    } else {
      return <MapOccupiedIcon />;
    }
  };

  return (
    <>
      <div
        className={`custom-marker custom-marker-tooltip-target-${targetId}`}
        style={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '28px',
          height: '28px',
        }}
        onClick={() => markerOnClicked({ data })}
      >
        <MarkerIcon />
      </div>
      <Tooltip
        target={`.custom-marker-tooltip-target-${targetId}`}
        position="top"
      >
        <div>
          <div>
            <b>{device_name}</b>
          </div>
          <div>{isAvailable ? COMMON_TEXT.VACANT : COMMON_TEXT.OCCUPIED}</div>
          {current_reservation && (
            <div>{COMMON_TEXT.CURRENT}: {current_reservation}</div>
          )}
          {next_reservation && (
            <div>{COMMON_TEXT.NEXT}: {next_reservation}</div>
          )}
        </div>
      </Tooltip>
    </>
  );
};
